"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "travo": {
    "75addeb8": [{
      "hkey": "25313ffd",
      "slug": "travo",
      "name": "Travo",
      "primary": true,
      "skipSearch": false
    }],
    "caverzago": [{
      "hkey": "25313ffd",
      "slug": "travo",
      "name": "Travo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc60a2c9": [{
      "hkey": "25313ffd",
      "slug": "travo",
      "name": "Travo",
      "primary": true,
      "skipSearch": false
    }],
    "fellino": [{
      "hkey": "25313ffd",
      "slug": "travo",
      "name": "Travo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c66d817": [{
      "hkey": "25313ffd",
      "slug": "travo",
      "name": "Travo",
      "primary": true,
      "skipSearch": false
    }],
    "pillori": [{
      "hkey": "25313ffd",
      "slug": "travo",
      "name": "Travo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12078a0b": [{
      "hkey": "5e20dcf9",
      "slug": "belvedere-di-statto",
      "name": "Belvedere di Statto",
      "primary": true,
      "skipSearch": false
    }],
    "statto": [{
      "hkey": "5e20dcf9",
      "slug": "belvedere-di-statto",
      "name": "Belvedere di Statto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;